<template>
  <div class="pageContainer">
    <div class="container mt-5">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="card loginCard">
            <div>
              <img src="../../../assets/images/logo.png" style="width: 35%; margin-top: 10px" />
              <h4>تسجيل الدخول</h4>
            </div>
            <div class="card-body">
              <form @submit.prevent="login">
                <div class="form-group">
                  <label for="email">البريد الإلكتروني</label>
                  <input type="email" class="form-control" id="email" v-model="email" />
                  <div class="text-danger">{{ errors.email }}</div>
                </div>
                <div class="form-group">
                  <label for="password">كلمة المرور</label>
                  <input type="password" class="form-control" id="password" v-model="password" />
                  <div class="text-danger">{{ errors.password }}</div>
                </div>
                <button type="submit" class="btn btn-primary">دخول</button>
                <div>
                  <small style="padding-right: 70%"><a href="/forget-password" class="text-info">هل نسيت كلمة
                      المرور؟</a></small>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Axios from "../../../Axios";
import Swal from "sweetalert2";
import * as yup from "yup";

const loginSchema = yup.object().shape({
  email: yup
    .string()
    .email("الرجاء إدخال بريد إلكتروني صحيح")
    .required("يرجى إدخال البريد الإلكتروني"),
  password: yup.string().required("يرجى إدخال كلمة المرور"),
});

export default {
  data() {
    return {
      email: "",
      password: "",
      errors: {},
    };
  },
  methods: {
    login(event) {
      const { email, password } = this;

      loginSchema
        .validate({ email, password }, { abortEarly: false })
        .then(() => {
          const formData = new FormData();
          formData.append('email', email);
          formData.append('password', password);

          Axios.post("/login", formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
            .then((response) => {
              const token = response.data.token;
              const expirationTime = Date.now() + 7 * 24 * 60 * 60 * 1000; //Every Week

              localStorage.setItem("adminToken", token);
              localStorage.setItem("expirationTime", expirationTime);

              const intervalId = setInterval(() => {
                const expirationTime = localStorage.getItem("expirationTime");
                if (parseInt(expirationTime) <= parseInt(Date.now())) {
                  localStorage.removeItem("adminToken");
                  localStorage.removeItem("expirationTime");
                  this.$router.push("/login");
                  clearInterval(intervalId);
                }
              }, 1000);
              Swal.fire({
                icon: "success",
                title: "تم تسجيل الدخول بنجاح!",
                confirmButtonText: "حسناً",
              }).then(() => {
                this.$router.push("/admin/overview");
                window.location.reload();
              });
            })
            .catch((error) => {
              // console.log(error);
              Swal.fire({
                icon: "error",
                title: "فشل تسجيل الدخول",
                text: "الرجاء التحقق من البريد الإلكتروني وكلمة المرور والمحاولة مرة أخرى.",
                confirmButtonText: "حسناً",
              });
            });
        })
        .catch((errors) => {
          const errorMessages = {};
          errors.inner.forEach((error) => {
            errorMessages[error.path] = error.message;
          });
          this.errors = errorMessages;
        });
    },

  },
};
</script>

<style>
.pageContainer {
  background-image: url(../../../assets/images/background.png);
  background-size: cover;
  height: 400px;
  margin-top: -50px;
}

.loginCard {
  margin-top: 65px;
  text-align: center;
  background-color: rgba(255, 255, 255, 0.389);
  border-radius: 8px;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1);
}

.loginCard input {
  background-color: rgba(255, 255, 255, 0.784);
}

.loginCard h4 {
  padding: 20px 0;
}
</style>
